// @owners { team: patients-team }
import { ActionSheetContext, AltoIcon, Card, Illustration, LgPadding, ListItem } from '@alto/design-system';
import React, { useContext } from 'react';
import HelpImage from '~shared/assets/images/help_bubble.png';
import { ASSISTANT_VIEWED_EVENTS } from '~shared/features/alto-assistant/analytics/constants';
import { sendAssistantViewedEvent } from '~shared/features/alto-assistant/analytics/helpers';
import { useDispatchShared } from '~shared/store';
import { HowCanWeHelpActionSheet } from '~web/features/alto-assistant/components/action-sheets/HowCanWeHelpActionSheet';

export const NewMessageCard = () => {
  const dispatch = useDispatchShared();
  const { setActiveActionSheet } = useContext(ActionSheetContext);

  const showTopicMenu = () => {
    dispatch(sendAssistantViewedEvent(ASSISTANT_VIEWED_EVENTS.CATEGORY_ACTION_SHEET));
    setActiveActionSheet(<HowCanWeHelpActionSheet />);
  };

  return (
    <Card overflow="hidden">
      <LgPadding>
        <ListItem
          fullBleed
          onPress={showTopicMenu}
          LeftContent={
            <Illustration
              source={HelpImage}
              accessibilityLabel="Help Bubble"
            />
          }
          title="New message"
          RightContent={
            <AltoIcon
              name="chevronright"
              type="grey"
            />
          }
        />
      </LgPadding>
    </Card>
  );
};
